<template>
  <div class="dsf-control ds-convenient-menu pc" :class="rootClass" :style="rootStyle" >
    <dsf-convenient-menu-group v-if="menuList.length === 1" :group="menuList[0]">
      <template #default="{ item, rowIndex, colIndex }">
        <slot :item="item" :page-index="0" :row-index="rowIndex" :col-index="colIndex">
          <dsf-convenient-menu-item :display-style="displayStyle" :item="item">
            <span
              v-if="enableMark!='' && isDesign?true:item.mark_type && badges[item.id] && badges[item.id].num"
              class="angle-mark"
              :class="[enableMark]"
              :style="markStyle">
              {{ isDesign?'99+': badges[item.id].num>99?'99+':badges[item.id].num}}
            </span>
          </dsf-convenient-menu-item>
        </slot>
      </template>
    </dsf-convenient-menu-group>
    <template v-else-if="menuList.length > 1">
      <el-carousel
        ref="carousel"
        :loop="false"
        :autoplay="false"
        height="100%"
        arrow="never"
        @wheel.native="onWheel"
        @change="activeIndex = $event">
        <el-carousel-item v-for="(group, index) in menuList" :key="index">
          <dsf-virtual-scroll>
            <dsf-convenient-menu-group :group="group">
              <template #default="{ item, rowIndex, colIndex }">
                <slot :item="item" :page-index="index" :row-index="rowIndex" :col-index="colIndex">
                  <dsf-convenient-menu-item :display-style="displayStyle" :item="item">
                    <span
                      v-if="enableMark!='' && isDesign?true:item.mark_type && badges[item.id] && badges[item.id].num"
                      class="angle-mark"
                      :class="[enableMark]"
                      :style="markStyle">
                      {{ isDesign?'99+': badges[item.id].num>99?'99+':badges[item.id].num}}
                    </span>
                  </dsf-convenient-menu-item>
                </slot>
              </template>
            </dsf-convenient-menu-group>
          </dsf-virtual-scroll>
        </el-carousel-item>
      </el-carousel>
      <template v-if="arrow && menuList.length > 1">
        <div class="ds-convenient-menu-arrow left" :class="{disabled: activeIndex == 0}">
          <i class="iconfont icon-arrow-left2" @click="$refs.carousel.prev()"></i>
        </div>
        <div class="ds-convenient-menu-arrow right" :class="{disabled: activeIndex == menuList.length - 1}">
          <i class="iconfont icon-arrow-right2" @click="$refs.carousel.next()"></i>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
const DsfConvenientMenuGroup = Vue.defineLazyComponent(() => require("./items/convenientMenuGroup"));
const DsfConvenientMenuItem = Vue.defineLazyComponent(() => require("./items/convenientMenuItem"));

export default dsf.component({
  name: "DsfConvenientMenu",
  mixins: [$mixins.convenientMenu],
  ctrlCaption: "快捷菜单",
  design: {
    isMask: false
  },
  components: {
    DsfConvenientMenuGroup,
    DsfConvenientMenuItem
  },
  props: {
    // 是否显示轮播切换箭头
    arrow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    this.__wheelDeltaStart = 0;
    return {};
  },
  computed: {
    rootClass() {
      let {menuList, arrow, innerHeightAuto, minHeight, height} = this;
      let res = [];
      if (arrow && menuList.length > 1) {
        res.push('arrow')
      }
      if (innerHeightAuto && height !== 'auto' && minHeight == 'none') {
        res.push('inner-auto')
      }
      return res;
    },
    rootStyle() {
      let res = {'min-height': this.minHeight};
      if (this.isDesign) {
        this.$dispatch("design-height-change", this.height);
        res.height = "100%";
      } else {
        res.height = this.height;
      }
      return res;
    },
    colStyle() {
      return {
        'padding': this.cellMargin.join(' ')
      };
    },
    boxStyle() {
      return {
        'padding': this.cellPadding.join(' '),
        'background-color': this.cellColor,
        'width': this.cellWidth,
        'border-radius': this.cellRadius
      };
    },
    iconStyle() {
      let res = {
        'width': this.iconWidth,
        'height': this.iconHeight,
        'border-radius': this.iconRadius,
        'background-color': dsf.themeConfig.getThemeColor(this.iconBgColor) || this.iconBgColor,
        'color': dsf.themeConfig.getThemeColor(this.iconFontColor) || this.iconFontColor,
        'font-size': this.iconFontSize,
        'font-weight': this.iconFontBold ? 'bold' : 'normal'
      };
      if (this.iconBgShadow) {
        res['box-shadow'] = '0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)';
      }
      if (this.iconFontShadow) {
        res['text-shadow'] = '0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)';
      }
      return res;
    },
    infoStyle() {
      let res = {};
      if (this.displayStyle === 'style1') {
        res['margin-top'] = this.iconAndInfoOfSpacing;
      } else if (this.displayStyle === 'style2') {
        res['margin-left'] = this.iconAndInfoOfSpacing;
      }
      return res;
    },
    markStyle() {
      let n = `calc(0.25 * ${this.iconRadius})`
      return {
        top: n,
        right: n
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.__timeout);
  },
  methods: {
    // 滚轮翻页
    onWheel(e) {
      let deltaX = e.deltaX * -1, deltaY = e.deltaY * -1;
      if (e.shiftKey && deltaY) {
        deltaX = deltaY;
        deltaY = 0;
      }
      if (dsf.client.type === "FF" && e.deltaMode === 1) {
        if (deltaX) deltaX = deltaX < 0 ? -100 : 100;
        if (deltaY) deltaY = deltaY < 0 ? -100 : 100;
      }
      let delta = deltaY || deltaX;
      if ((delta > 0 && this.lastDelta < 0) || (delta < 0 && this.lastDelta > 0)) {
        this.__wheelDeltaStart = 0;
        this.lastDelta = delta;
      }
      clearTimeout(this.__timeout);
      this.__wheelDeltaStart += delta;
      let offset = delta - this.__wheelDeltaStart;
      if ((offset < 0 && this.activeIndex > 0) || (offset > 0 && this.activeIndex < this.menuList.length - 1)) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (offset <= -300 && this.activeIndex > 0) {
        this.$refs.carousel.prev();
        this.__wheelDeltaStart = 0;
      } else if (offset >= 300 && this.activeIndex < this.menuList.length - 1) {
        this.$refs.carousel.next();
        this.__wheelDeltaStart = 0;
      } else if (offset <= -300 || offset >= 300) {
        this.__wheelDeltaStart = 0;
      } else {
        this.__timeout = setTimeout(() => {
          this.__wheelDeltaStart = 0;
        }, 300);
      }
    }
  }
});
</script>